<template>
    <div class="memo-item-box" :class="{ 'popup-mode': isWidgetMode }">
        <div v-if="!isWidgetMode" class="memo-item-header d-flex justify-content-end" @click="showMemoWidget">
            <span class="message-notifi">Message</span>
            <div class="count-noti font-size-12-px d-flex align-items-center justify-content-center noti">42</div>
        </div>
        <div v-if="isWidgetMode" class="memo-item-header-title border border-black d-flex align-items-center justify-content-end w-100">
            <div class="memo-item-header d-flex align-items-center pl-5-px pr-5-px height-30-px">
                <div class="d-flex align-items-center column-gap-5-px">
                    <button
                        v-if="isWidgetMode && isShowCloseButton"
                        @click="handleCloseClick"
                        class="memo-close-button btn btn-danger"
                        :class="classes.closeButton"
                        title="Close"
                    >
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>
            </div>
        </div>
        <div
            v-if="isWidgetMode"
            class="memo-item-content border border-top-0 border-black overflow-auto p-1"
            :class="{
                'height-160-px': !isWidgetMode,
                'popup-content-height': isWidgetMode
            }"
        >
            <div class="d-flex align-items-center justify-content-start gap-2 mb-2">
                <ans-input input-class="custom-border text-end" v-model="fakeData" />
                <span class="text-blue"><i class="fa-solid fa-square-plus"></i> 新規メッセージ</span>
            </div>
            <div class="d-flex">
                <div class="border border-black p-1">すべて</div>
                <div class="border border-black p-1">社内DM</div>
                <div class="border border-black p-1">社外DM</div>
                <div class="border border-black p-1">システム</div>
            </div>
            <div class="mt-2">
                <table v-for="(notice, index) in notices" :key="index" class="notice-table">
                    <tr>
                        <td class="title-notice">{{ notice.type }}</td>
                        <td class="sender">{{ notice.sender }}</td>
                    </tr>
                    <tr>
                        <td class="content" colspan="2">{{ notice.content }}</td>
                    </tr>
                    <tr class="footer">
                        <td>{{ notice.target }}</td>
                        <td class="time">{{ notice.time }}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { showWidgetWithPreset, toggleWidgetContent } from '@/utils/widget';
import { markRaw } from 'vue';

export default {
    name: 'MessageComponent',
    props: {
        // When used as popup
        isWidgetMode: {
            type: Boolean,
            default: false
        },
        initialMemo: {
            type: String,
            default: ''
        },
        // Close button configuration
        isShowCloseButton: {
            type: Boolean,
            default: true
        },
        classes: {
            type: Object,
            default: () => ({
                closeButton: ''
            })
        }
    },
    data() {
        return {
            isEditMode: false,
            editMemo: '',
            fakeData: '',
            notices: [
                {
                    type: '社内DM',
                    sender: '返野',
                    content: '20日の会議について',
                    target: '@ALL',
                    time: '9/16(火) 10:48'
                },
                {
                    type: 'システム',
                    sender: 'ANS木村',
                    content: 'メンテナンス 28(日)22:00〜翌03:00',
                    target: '@ALL',
                    time: '9/16(火) 10:48'
                },
                {
                    type: '社内DM',
                    sender: '返野',
                    content: '27日の会議について',
                    target: '@ALL',
                    time: '9/16(火) 10:48'
                },
                {
                    type: '社外DM',
                    sender: '㈱セレネオ',
                    content: '見積作成依頼',
                    target: '@コントロールセンター',
                    time: '9/16(火) 10:48'
                },
                {
                    type: '社内DM',
                    sender: '返野',
                    content: '10/07の会議について',
                    target: '@ALL',
                    time: '9/16(火) 10:48'
                },
                {
                    type: 'システム',
                    sender: 'ANS木村',
                    content: '新機能の説明',
                    target: '@ALL',
                    time: '9/16(火) 10:48'
                }
            ]
        };
    },
    computed: {},
    mounted() {
        if (this.isWidgetMode) {
            // Initialize edit memo with store data when used as popup
            this.editMemo = this.data?.order_note || '';
        }
    },

    methods: {
        showMemoWidget() {
            showWidgetWithPreset('help', {
                component: markRaw(this.$options), // Use current component definition
                showIconToggle: false, // Always show icon even when content is visible
                showCloseButton: false, // Hide the close button in the widget
                // Custom icon for the widget
                iconElement: 'i', // Use FontAwesome icon
                iconProps: {
                    class: {
                        show: 'fa-solid fa-arrow-down',
                        hide: 'fa-solid fa-arrow-up'
                    }
                },
                styles: {
                    icon: {
                        background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)'
                    }
                    // content: {
                    //     width: '300px',
                    //     height: '95vh',
                    //     maxHeight: '95vh'
                    // }
                },
                componentProps: {
                    isWidgetMode: true,
                    initialMemo: this.data?.order_note || '',
                    isShowCloseButton: true,
                    classes: {
                        closeButton: 'custom-close-btn'
                    }
                },
                offset: {
                    x: 20,
                    y: 310
                },
                onClose: () => {}
            });

            // Show content immediately after showing widget
            this.$nextTick(() => {
                toggleWidgetContent(true);
            });
        },

        toggleMemoWidget() {
            // Toggle widget content visibility
            toggleWidgetContent();
        },

        handleCloseClick() {
            // Close widget when close button is clicked
            if (this.isWidgetMode) {
                // Emit close event to trigger widget close
                this.$emit('close');
            }
        },

        handleActionClick() {
            if (this.isEditMode) {
                // Save mode - save and switch back to view mode
                this.saveMemo();
            } else {
                // Edit mode - switch to edit mode and focus textarea
                this.isEditMode = true;
                this.$nextTick(() => {
                    if (this.$refs.memoTextarea) {
                        this.$refs.memoTextarea.focus();
                    }
                });
            }
        },

        saveMemo() {
            // XSS protection - sanitize input before saving
            const sanitizedMemo = this.sanitizeInput(this.editMemo);

            if (this.isWidgetMode) {
                // In popup mode: update store directly and switch back to view mode
                this.setOrderData({ order_note: sanitizedMemo });
                this.isEditMode = false;
            } else {
                // In normal mode: emit save event (if needed)
                this.$emit('save', sanitizedMemo);
                this.isEditMode = false;
            }
        },

        sanitizeInput(input) {
            // Basic XSS protection - remove dangerous characters and scripts
            if (!input) return '';

            return input
                .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '') // Remove script tags
                .replace(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi, '') // Remove iframe tags
                .replace(/javascript:/gi, '') // Remove javascript: protocols
                .replace(/on\w+\s*=/gi, '') // Remove event handlers
                .trim();
        }
    }
};
</script>

<style lang="scss" scoped>
.memo-item-box {
    background-color: #fff;
    font-size: 14px !important;

    .message-notifi {
        color: #0d6efd;
    }

    .text-blue {
        color: #0d6efd;
    }

    .count-noti {
        width: 20px;
        height: 20px;
        margin: 3px 5px;
    }

    .noti {
        border-radius: 100%;
        background-color: red;
        color: white;
    }

    &:not(.popup-mode) {
        flex-basis: 300px;
        flex-shrink: 0;
    }

    &.popup-mode {
        height: 100%;
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
    }

    .memo-item-header {
        // background-color: #6495ed;
        flex-shrink: 0;

        .memo-action-button {
            height: 25px;
            padding: 2px 8px;
            font-size: 11px;
        }

        .memo-close-button {
            height: 25px;
            width: 25px;
            padding: 2px 8px;
            font-size: 11px;
            color: white;
            font-weight: bold;
            transition: all 0.2s ease;
        }
    }

    .memo-item-content {
        &.popup-content-height {
            flex: 1;
            height: auto !important;
        }

        .memo-item-content-text {
            font-size: 11px;
            white-space: pre-wrap;
            word-wrap: break-word;
            line-height: 1.4;
        }

        .memo-edit-container {
            height: 100%;

            .memo-textarea {
                width: 100%;
                height: 100%;
                resize: none;
                font-size: 11px;
                line-height: 1.4;
                border: 1px solid #ddd;

                &:focus {
                    outline: none;
                    border-color: #007bff;
                    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
                }
            }
        }
    }
    .notice-table {
        width: 100%;
        border-collapse: collapse;
        border: 1px solid #000;
        font-family: sans-serif;
        font-size: 11px;
    }

    .notice-table td {
        border: 1px solid #000;
        padding: 4px 6px;
        vertical-align: top;
    }

    .notice-table .title-notice {
        width: 70%;
        font-weight: bold;
    }

    .notice-table .sender {
        text-align: right;
        width: 30%;
        white-space: nowrap;
    }

    .notice-table .content {
        padding: 6px;
    }

    .notice-table .footer td,
    .notice-table .footer {
        font-size: 11px;
        color: #333;
    }
    .notice-table .time {
        text-align: right;
    }
}
</style>
